import * as yup from 'yup';

let leadSchema = yup.object().shape({
    first_name: yup.string().required(),
    company: yup.string().required()
});

export {leadSchema}
